import { render, staticRenderFns } from "./FileDowload.vue?vue&type=template&id=2106dca4"
import script from "./FileDowload.vue?vue&type=script&lang=js"
export * from "./FileDowload.vue?vue&type=script&lang=js"
import style0 from "./FileDowload.vue?vue&type=style&index=0&id=2106dca4&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports